import React, { useCallback, useMemo, useState } from 'react'

import { config } from 'config/config'
import { onClientSide } from '@/utils/utils'
import PromoBlackFairModal from '../components/PromoBlackFairModal'

const useBlackFair = () => {
  const [canShowModal, setCanShowModal] = useState(true)
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [isCampaignActive, setIsCampaignActive] = useState(false)

  const init = (leadSent = false) => {
    if (!leadSent) return

    if (onClientSide()) {
      const isActive = window.localStorage.getItem(
        config.blackFairAdAIsKeyActive
      )
      const isAlreadyParticipating = window.localStorage.getItem(
        config.promoBlackFairao2024
      )

      try {
        const isActiveParsed = Boolean(JSON.parse(isActive))
        const isAlreadyParticipatingParsed = Boolean(
          JSON.parse(isAlreadyParticipating)
        )

        if (isAlreadyParticipatingParsed) {
          setCanShowModal(false)
        }

        if (!isActiveParsed) return

        if (isActiveParsed) {
          setIsCampaignActive(true)
        }

        setIsModalOpened(true)
      } catch (error) {
        console.warn(
          'Failed to parse localStorage value for hasPromoBlackFair2024 at useBlackFair:',
          error
        )
      }
    }
  }

  const shouldShowModal = useMemo(() => {
    return canShowModal && isModalOpened && isCampaignActive
  }, [canShowModal, isModalOpened, isCampaignActive])

  const renderModal = useCallback(
    email => {
      if (shouldShowModal) {
        const shouldHideModal = window.localStorage.getItem(
          config.hideModalPromoBlackFairao2024
        )

        if (shouldHideModal !== null) {
          window.localStorage.removeItem(config.hideModalPromoBlackFairao2024)
        }
      }

      return shouldShowModal ? (
        <PromoBlackFairModal email={email} showMessageSent={false} />
      ) : null
    },
    [shouldShowModal]
  )

  return {
    init,
    renderModal,
    canShowModal,
    isModalOpened,
    isCampaignActive,
    shouldShowModal,
  }
}

export default useBlackFair